"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeSelect = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = require("../Icon");
var _NativeOption = require("./NativeOption");
var _lodash = require("lodash");
var _excluded = ["children", "disabled", "error", "iconStyles", "label", "onChange", "selectWrapperStyles", "value"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
// TODO: implement contained styles
var NativeSelect = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    error = _ref.error,
    iconStyles = _ref.iconStyles,
    label = _ref.label,
    onChange = _ref.onChange,
    selectWrapperStyles = _ref.selectWrapperStyles,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  // Assume that if value is truthy, there is display text
  var _useState = (0, _react.useState)(!!value),
    _useState2 = _slicedToArray(_useState, 2),
    hasDisplayText = _useState2[0],
    setHasDisplayText = _useState2[1];
  var handleChange = function handleChange(e) {
    setHasDisplayText(!!children[e.target.selectedIndex].props.children);
    onChange(e.target.value);
  };
  (0, _react.useEffect)(function () {
    if (!value) {
      // Mimic native behavior where first option is automatically selected
      // if a falsy value is provided and no option with that value exists
      var childArray = _react.default.Children.toArray(children);
      var childWithFalsyValue = childArray.find(function (child) {
        return child.props.value === value;
      });
      if (!childWithFalsyValue) {
        handleChange({
          target: {
            value: children[0].props.value,
            selectedIndex: 0
          }
        });
      }
    }
  }, [value]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('flex relative pt-[23px] pb-[6px] box-border border-0 border-b border-solid', error ? 'border-alertred-60' : 'border-grey-45', selectWrapperStyles)
  }, /*#__PURE__*/_react.default.createElement("select", _extends({
    ref: ref,
    id: (0, _lodash.kebabCase)(label),
    "aria-describedby": "".concat((0, _lodash.kebabCase)(label), "-description"),
    className: (0, _classnames.default)('select-input tw-label-regular w-full peer appearance-none disabled:cursor-not-allowed'),
    disabled: disabled,
    value: value,
    onChange: handleChange
  }, props), children), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    type: "caret-down-medium-16",
    className: (0, _classnames.default)('text-black', iconStyles)
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)('select-input-label absolute ml-[2px] pointer-events-none', hasDisplayText ? 'tw-caption-regular ' : 'tw-label-regular', 'top-0', 'peer-disabled:cursor-not-allowed peer-disabled:text-grey-40', 'peer-focus:tw-caption-regular peer-focus:top-0', {
      'text-grey-45 peer-focus:text-grey-45': !error
    }),
    htmlFor: (0, _lodash.kebabCase)(label)
  }, label));
});
exports.NativeSelect = NativeSelect;
NativeSelect.Option = _NativeOption.NativeOption;
NativeSelect.propTypes = {
  children: _propTypes.default.arrayOf(_NativeOption.NativeOption).isRequired,
  selectWrapperStyles: _propTypes.default.string,
  iconStyles: _propTypes.default.string,
  /**
   * Text for the floating label. Because the styling is fairly complex,
   * no additional styles are currently permitted.
   */
  label: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  isValidState: _propTypes.default.bool
};